module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921021149_T.cb110470.jpg";